import { createI18n } from 'vue-i18n';

// Get saved locale from localStorage or default to UA
const savedLocale = localStorage.getItem('iprod-locale') || 'UA';

// Track loaded locales
const loadedLocales = [];

// Create i18n instance without messages (will be loaded dynamically)
const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'UA',
  messages: {},
  globalInjection: true
});

// Lazy load a locale
export async function loadLocaleMessages(locale) {
  // If already loaded, just switch
  if (loadedLocales.includes(locale)) {
    i18n.global.locale.value = locale;
    return;
  }

  // Dynamic import based on locale
  const messages = await import(`@/localization/${locale.toLowerCase()}.js`);

  // Set the locale messages
  i18n.global.setLocaleMessage(locale, messages.default);
  loadedLocales.push(locale);

  // Switch to the locale
  i18n.global.locale.value = locale;
}

// Load initial locale
loadLocaleMessages(savedLocale);

export default i18n;
